import { createSlice } from "@reduxjs/toolkit";
import { IStore } from "helpers";

export const userReducer = createSlice({
  name: "user store",
  initialState: {
    roles: [],
    userInfo: {
      name: "",
      email: "",
      user_id: "",
    },
    roleBuyer: false,
    permissions: [],
  },
  reducers: {
    setRoles: (state, action) => {
      state.roles = action.payload;
    },
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    setUserPermissions: (state, action) => {
      state.permissions = action.payload;
    },
  },
});

export const { setRoles, setUserInfo, setUserPermissions } = userReducer.actions;

export const getRoles = (state: IStore) => state.user.roles;
export const getUserInfo = (state: IStore) => state.user.userInfo;
export const getUserPermissions = (state: IStore) => state.user.permissions;
export default userReducer.reducer;
